<template>
    <v-container fluid class="pt-0">
        <v-row>

            <v-col cols="12" class="pa-0">
                <v-sheet class="" color="#008dd4" height="10vh"></v-sheet>
            </v-col>

            <v-col cols="12" lg="3" style="position:relative; top: -60px">
                <v-card>
                    <v-date-picker
                        v-model="dates"
                        range
                        color="green lighten-1"
                        header-color="primary"
                        @change="date_change"
                    ></v-date-picker>
                </v-card>
            </v-col>
            <v-col cols="12" lg="9" style="position:relative; top: -60px">
                <v-card>
                    <v-data-table
                        :headers="headers"
                        :items="items"
                        :single-expand=true
                        :expanded.sync="expanded"
                        :loading="loading"
                        item-key="id"
                        show-expand
                        class="elevation-1"
                    >
                        <template v-slot:expanded-item="{ headers, item }">
                        <td :colspan="headers.length">
                            More info about 
                        </td>
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>

            
        </v-row>

    </v-container>
</template>
<script>

import authorized from './authorized'

export default {
    components:{
        authorized
    },

    data: () => ({
        //urls
        data_url:"/teachers/payments",
        store_url:"/teachers/authorized",

        //dialogs
        authorized_dialog : false,

        //items
        authorized_item : [],

        //recordings_dialog
        recordings_dialog:false,
        recordings_item:"",
        watch_item:"",
        watch:false,

        //dates 
        dates: [(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)],

        //props
        items:[],

        //data table props
        color:"#008dd4",
        search:"",
        loading:"#008dd4",
        loading_text:"Cargando...",
        no_data_text:"Sin elementos registrados",
        no_result_text:"Sin coincidencias",
        headers:[
            { text:'ID',          value:'id' },
            { text:'Nombre(s)',   value:'fullname' },
            { text: 'Videos', value: 'total_recordings' },
            { text:'Pago De Videos',      value:'recordings_payments' },
            { text: 'Enlaces', value: 'total_lessons' },
            { text:'Pago De Enlaces',      value:'lessons_payments' },
        ],
        expanded: [],
        footer_props:{
            itemsPerPageText:"Filas por página",
            showCurrentPage:true,
            itemsPerPageAllText:"Todo"
        },

        //recordings data table
        headers_recordings:[
            { text:'ID',        value:'id' },
            { text:'Curso',     value:'course.name' },
            { text:'Nivel',     value:'course.level.name' },
            { text:'Modalidad', value:'course.modality.name'},
            { text:'Horario',   value:'course.schedule[0].start_time' },
            { text:'Video',     value:'video' },
            { text: 'Registro', value:'realDate'}
        ],
    }),

    mounted(){
        this.getData()
    },

    methods:{
        getData:function(){
            axios.get(this.data_url, { params:{ ajax:true,  initial_date: this.dates[0], final_date: this.dates[1] }}).then(response => {
                console.log(response.data)
                this.items = response.data.items
                this.loading = false
                this.items.forEach(element => {
                    var recordings = 0
                    var lessons = 0
                    var lessons_payments =  0
                    var recordings_payments = 0
                    element.teacher_courses.forEach(course => {
                        recordings += course.total_recordings
                        lessons += course.total_lessons
                        var price_per_hour = course.language_id == 1 ? 75 : 100
                        var hours_per_class = course.modality_id == 1 ? 1 : (course.modality_id == 2 ? 1.5 : 3)
                        course.recordings_payments = price_per_hour * hours_per_class * course.total_recordings
                        course.lessons_payments = price_per_hour * hours_per_class * course.total_lessons
                        recordings_payments += course.recordings_payments
                        lessons_payments += course.lessons_payments
                    });
                    element.total_recordings = recordings
                    element.total_lessons = lessons
                    element.lessons_payments = lessons_payments
                    element.recordings_payments = recordings_payments
                });
                
            }).catch(error => {
                this.loading = false
                console.log(error)
            })
        },

        getItem:function(item){
            return Object.assign({}, this.items[this.items.indexOf(item)])
        },
        date_change: function(){
            this.loading = true
            this.getData();

        },

        show:function(item){},

        edit:function(item){},

        status:function(item){},

        authorized:function(item){
            this.authorized_item = this.getItem(item)
            this.authorized_dialog = true
        },

        reset_watch:function(){
            this.watch_item = ""
            this.watch = false
        },

        remove:function(item){}
    }
}
</script>
